import { Component, Input } from '@angular/core';


@Component({
    selector: 'app-chart-circle-somple',
    templateUrl: './circle-simple.component.html',
})
export class ChartCircleSimpleComponent {
    @Input()
    public defaultFill: string = '#fff';

    @Input()
    public defaultStroke: string = '#e6e6e6';

    @Input()
    public defaultMainStroke: string = '#4f7cff';

    @Input()
    public percentage?: number = 100;

    @Input()
    public text?: string;

    public constructor(

    ) {}


    get prct(): number {
        let prct = this.percentage;
        if (!this.percentage && this.percentage !== 0) {
            prct = 100;
        }
        return 439.8 * (1 - prct! / 100);
    }
}
